import React from "react";

const TermsAndConditions = () => {
  return (
    <section className="w-full bg-gradient-radial py-12 lg:py-16">
      <div className="container mx-auto px-4 lg:px-12">
        {/* Heading */}
        <div className="text-center my-10">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold font-inter !text-white">
            Terms & Conditions
          </h1>
          <p className="mt-2 text-base sm:text-lg lg:text-xl font-medium font-inter text-white/70">
            Please read these terms carefully before using FWPI services
          </p>
        </div>

        {/* Content Card */}
        <div className="bg-[#181B23] rounded-[24px] backdrop-blur-lg border border-slate-950/10 px-5 py-8 sm:p-10 lg:p-12 text-white/80 font-inter space-y-8 leading-relaxed">

          <p>
            Welcome to <span className="text-white font-semibold">Fitness & Wellness Professionals of India (FWPI)</span>. 
            By accessing or using our website <span className="text-white">fwpiindia.com</span> and our services, you agree 
            to comply with and be bound by the following Terms & Conditions. If you do not agree, please do not use our platform.
          </p>

          <div>
            <h2 className="text-2xl font-bold text-white mb-2">
              1. About FWPI
            </h2>
            <p>
              FWPI is a professional membership body and independent accreditation authority for fitness, wellness, nutrition, 
              therapy professionals, institutions, gyms, and studios across India, operating under recognized standards and 
              ethical practices.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-2">
              2. Eligibility
            </h2>
            <p>
              By using FWPI services, you confirm that you are at least 18 years of age and capable of entering into 
              a legally binding agreement under applicable Indian laws.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-2">
              3. Use of Website & Services
            </h2>
            <p>
              You agree to use FWPI’s website and services only for lawful purposes. You must not misuse the platform, 
              attempt unauthorized access, or engage in activities that may harm FWPI or other users.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-2">
              4. Membership & Accreditation
            </h2>
            <p>
              All memberships, accreditations, certifications, and recognitions provided by FWPI are subject to 
              verification, review, and approval as per FWPI’s standards and policies. FWPI reserves the right to 
              approve, reject, suspend, or revoke any membership or accreditation without prior notice if standards 
              or ethical conduct are violated.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-2">
              5. Fees & Payments
            </h2>
            <p>
              Certain services may require payment of fees. All fees are non-refundable unless explicitly stated. 
              FWPI reserves the right to revise its pricing at any time without prior notice.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-2">
              6. Intellectual Property
            </h2>
            <p>
              All content, logos, trademarks, designs, and materials on fwpiindia.com are the intellectual property 
              of FWPI and may not be copied, reproduced, or used without prior written consent.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-2">
              7. Limitation of Liability
            </h2>
            <p>
              FWPI shall not be liable for any direct, indirect, incidental, or consequential damages arising from 
              your use of the website or services, including reliance on any information provided.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-2">
              8. Termination
            </h2>
            <p>
              FWPI reserves the right to terminate or suspend access to its services immediately, without prior notice, 
              for conduct that violates these Terms or is harmful to FWPI or its community.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-2">
              9. Governing Law
            </h2>
            <p>
              These Terms & Conditions shall be governed and construed in accordance with the laws of India. 
              Any disputes shall be subject to the exclusive jurisdiction of courts in India.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-2">
              10. Changes to Terms
            </h2>
            <p>
              FWPI may revise these Terms & Conditions at any time. Continued use of the website after changes 
              implies acceptance of the updated terms.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-2">
              11. Contact Information
            </h2>
            <p>
              For any questions regarding these Terms & Conditions, you may contact us:
            </p>
            <ul className="mt-2 space-y-1">
              <li>🌐 Website: <span className="text-white">fwpiindia.com</span></li>
              <li>📧 Email: <a href="mailto:support@fwpiindia.com" className="text-white hover:!text-gray-400">support@fwpiindia.com</a></li>
              <li>📞 Phone: <a href="tel:9996108446" className="text-white hover:!text-gray-400">+91 9996108446</a></li>
            </ul>
          </div>

          <p className="pt-6 text-center text-white/60 italic">
            Every credible wellness journey begins with FWPI
          </p>
        </div>
      </div>
    </section>
  );
};

export { TermsAndConditions };
